export default __webpack_public_path__ + "static/media/gallery_05.c7f8ca1c.jpg";